import React from 'react';
import { Card, CardMedia, Typography, Box } from '@mui/material';

function CategoryCard({ categoryImage, categoryName }) {
    return (
        <Card sx={{ position: 'relative', maxWidth: 345, margin: 'auto', cursor:'pointer' }}>
            {/* Image background */}
            <CardMedia
                component="img"
                // height="200"
                image={categoryImage}
                alt="Sample Image"
            />

            {/* Text overlay positioned in the bottom-left */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    color: 'white',
                    backgroundColor: '#4CAF50', // Transparent black background
                    padding: '10px',
                    width: '100%',
                }}
            >
                <Typography variant="h5" component="div">
                    {categoryName}
                </Typography>

            </Box>
        </Card>
    );
}

export default CategoryCard;
